<template>
  <b-modal ref="dynamicActivitySchedulingContainer" :hide-header="true" :hide-footer="true" scrollable :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" :body-class="[]">
    <b-container fluid class="dynamic-scheduler-container" @click="closeAllDropdown()">
      <b-row class="header">
        <b-col cols="12">
          <span class="title">Dynamic Scheduling</span>
          <span class="step-count">{{ stepCounter }} of 3</span>
        </b-col>
      </b-row>

      <!-- set triggers, step #1, starts -->
      <trigger-configuration-step ref="conditionsConfigurator" v-show="stepCounter === 1" :triggersRelatedDetails="triggersRelatedDetails" :taskDetails="taskDetails" :editConditionsData="dynamicScheduling.conditions" @disableNextButton="disableNextButton($event)" />
      <!-- set triggers, step #1, ends -->

      <!-- set actions, step #2, starts -->
      <actions-configuration-step ref="actionsConfigurator" v-show="stepCounter === 2" :actionRelatedDetails="actionRelatedDetails" :taskDetails="taskDetails" :editActionsData="dynamicScheduling.actions" :addOrEditMode="addOrEditMode" @disableNextButton="disableNextButton($event)" />
      <!-- set actions, step #2, ends -->

      <!-- set scheduling, step #3, starts -->
      <scheduling-configuration-step ref="schedulingsConfigurator" v-show="stepCounter === 3" :taskDetails="taskDetails" :editSchedulingData="dynamicScheduling.scheduling" />
      <!-- set scheduling, step #3, ends -->

      <b-row class="pl-13 pr-13">
        <b-col cols="2" class="d-flex align-items-center">
          <i class="fa fa-caret-left gray-clr" v-if="stepCounter !== 1"></i>
          <button class="footer-btns-container back" @click="back">
            {{ stepCounter !== 1 ? "Back" : "" }}
          </button>
        </b-col>
        <b-col cols="10" class="d-flex justify-content-end">
          <button class="footer-btns-container cancel" @click="closeModal">
            Cancel
          </button>
          <button class="footer-btns-container save" :disabled="disableNext" @click="next">
            {{ stepCounter !== 3 ? "Next" : "Save" }}
          </button>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import TriggerConfigurationStep from "./trigger-configuration-step";
import ActionsConfigurationStep from "./actions-configuration-step";
import SchedulingConfigurationStep from "./scheduling-configuration-step";
import { mapGetters, mapActions } from "vuex";
import { cloneDeep, orderBy } from "lodash";
import swal from "sweetalert2";

export default {
  name: "dynamic-activity-scheduling-modal",
  components: {
    TriggerConfigurationStep,
    ActionsConfigurationStep,
    SchedulingConfigurationStep
  },
  data() {
    return {
      stepCounter: 1,
      actionRelatedDetails: null,
      dynamicScheduling: {
        conditions: null,
        actions: null,
        scheduling: null
      },
      editIndex: null,
      addOrEditMode: "add",
      disableNext: false,
      dynamicSchedulingDefaultValue: {
        actions: [],
        conditions: [],
        scheduling: []
      },
      conditionFormModifyStatus: true,
      actionFormModifyStatus: true,
      schedulerFormModifyStatus: true
    };
  },
  props: {
    taskDetails: {
      type: [Object, String],
      default: null
    },
    triggersRelatedDetails: {
      type: Object,
      required: false,
      default: null
    },
    studyData: Object
  },
  mounted() {
    this.$api.getActionDetails(this.$route.params.studyId).then(data => {
      this.actionRelatedDetails = data.body; /* Removes current activity from activity list */
      /* this.actionRelatedDetails = this.actionRelatedDetails.filter( activity => { return activity.taskID != this.$route.params["surveyId"]; } ); */ this.actionRelatedDetails = this.actionRelatedDetails.filter(activity => {
        return activity.taskType !== "PACKET";
      });
      this.actionRelatedDetails = orderBy(this.actionRelatedDetails, [activity => activity["taskTitle"].toLowerCase()], ["asc"]);
    });
  },
  methods: {
    ...mapActions(["setDynamicActivitySchedules", "setConfiguredTriggersData", "setConfiguredActionsData"]),
    openModal() {
      this.$refs.dynamicActivitySchedulingContainer.show();
    },
    next() {
      this.getFormValues();
      switch (this.stepCounter) {
        case 1:
          this.setConfiguredTriggersData(this.$refs["conditionsConfigurator"].conditions);
          this.dynamicScheduling["conditions"] = this.$refs["conditionsConfigurator"].conditions;
          this.stepCounter++;
          this.$refs["actionsConfigurator"].validateAction();
          this.$forceUpdate();
          break;
        case 2:
          this.setConfiguredActionsData(this.$refs["actionsConfigurator"].actions);
          this.dynamicScheduling["actions"] = this.$refs["actionsConfigurator"].actions;
          this.stepCounter++;
          break;
        case 3:
          const valid = this.$refs["schedulingsConfigurator"].checkValidation(this.$refs["schedulingsConfigurator"].scheduler);
          if (!valid) {
            return;
          }

          this.dynamicScheduling["scheduling"] = this.$refs["schedulingsConfigurator"].scheduling;
          const tempSchedule = this.getDynamicActivitySchedules && [...this.getDynamicActivitySchedules];
          if (!this.getDynamicActivitySchedules) {
            this.setDynamicActivitySchedules([].push(cloneDeep(this.dynamicScheduling)));
          } else {
            if (this.addOrEditMode === "edit") {
              /* Editing a saved Dynamic Schedule */
              if (this.getDynamicActivitySchedules && this.getDynamicActivitySchedules.length) {
                tempSchedule.splice(this.editIndex, 1, cloneDeep(this.dynamicScheduling));
                this.setDynamicActivitySchedules(tempSchedule);
              }
            } else {
              tempSchedule.push(cloneDeep(this.dynamicScheduling)); /* Adding a new Dynamic Schedule */
              this.setDynamicActivitySchedules(tempSchedule);
            }
          }
          this.saveAndCloseModal();
          break;
        default:
          break;
      }
    },
    back() {
      this.getFormValues();
      if (this.stepCounter > 1) {
        this.stepCounter--;
      }
      this.disableNext = false;
      this.$root.$emit("ds-back-button-clicked", true);
    },
    closeAllDropdown() {
      this.$root.$emit("close-all-drop-downs", "all"); // this will close all dropdown(single & multi)
    },
    closeModal() {
      //compare value from getformvalues method
      this.getFormValues();
      if (this.conditionFormModifyStatus && this.actionFormModifyStatus && this.schedulerFormModifyStatus) {
        //if three of condition is true only when confirmatio box will not appear
        this.hideModal();
        this.stepCounter = 1;
        return;
      }
      swal({
        title: "Are you sure you want to exit?<br> Any progress you have made will not be saved.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#4c8ce4",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.hideModal();
          this.stepCounter = 1;
        }
      });
    },
    saveAndCloseModal() {
      this.setConfiguredTriggersData(null);
      this.setConfiguredActionsData(null);
      this.hideModal();
      this.stepCounter = 1;
    },
    hideModal() {
      this.resetDataValues();
      this.$forceUpdate();
      this.$refs.dynamicActivitySchedulingContainer.hide();
      this.conditionFormModifyStatus = true;
      this.actionFormModifyStatus = true;
      this.schedulerFormModifyStatus = true;
    },
    resetDataValues() {
      this.dynamicScheduling = {
        conditions: [],
        actions: [],
        scheduling: []
      };
      this.$forceUpdate();
    },
    disableNextButton(event) {
      this.disableNext = event === true;
      this.$forceUpdate();
    },
    // ------------------------------------------------------
    // |     changes on form Data checking method start here |
    // ------------------------------------------------------
    getFormValues() {
      const mode = this.addOrEditMode;
      const i = this.editIndex;
      if (mode == "edit") {
        //assign old data on update dynamic shchedule
        this.dynamicSchedulingDefaultValue["actions"] = this.getDynamicActivitySchedules[i]["actions"];
        this.dynamicSchedulingDefaultValue["conditions"] = this.getDynamicActivitySchedules[i]["conditions"];
        this.dynamicSchedulingDefaultValue["scheduling"] = this.getDynamicActivitySchedules[i]["scheduling"][0];
      }
      switch (
        this.stepCounter //code will handle one at one time
      ) {
        case 1:
          const conditionFormData = this.$refs["conditionsConfigurator"].conditions;
          const defaultConditions = [
            {
              // condition default data on add case
              trigger: "",
              isPrimaryCondition: true,
              field: "",
              value: "",
              operator: "",
              milestones: ""
            }
          ];
          //calling checkDynamicFormAddHistory method for checking information for condition
          this.conditionFormModifyStatus = this.checkDynamicFormAddHistory(conditionFormData, mode != "edit" ? defaultConditions : this.dynamicSchedulingDefaultValue["conditions"]);
          break;
        case 2:
          const actionFormData = this.$refs["actionsConfigurator"].actions;
          const defaultAction = [
            {
              // action default data on add case
              type: "",
              sequence: null,
              taskId: "",
              tasks: []
            }
          ];
          //calling checkDynamicFormAddHistory method for checking information for action
          this.actionFormModifyStatus = this.checkDynamicFormAddHistory(actionFormData, mode != "edit" ? defaultAction : this.dynamicSchedulingDefaultValue["actions"]);
          break;
        case 3:
          const schedulerFormData = this.$refs["schedulingsConfigurator"].cloneMethodOfSaveSchedule();
          let updateData = {};
          if (mode == "edit") {
            updateData = this.dynamicSchedulingDefaultValue["scheduling"];
          }
          const defaultScheduler = {
            // scheduler default data on add case
            type: "milestone",
            milestones: [],
            frequency: { type: null, title: null, days: null },
            startDay: null,
            endDay: null,
            completionWindow: null,
            notificaitons: [],
            allowMultipleTimes: false,
            allowUntillDuration: false,
            showDailySummary: false,
            duration: [{ startDay: null, endDay: null }],
            activitySchedulingMode: "schedule"
          };
          //constant or enum case handling start
          if (mode == "edit" && (schedulerFormData.type == "milestone" || schedulerFormData.type == "custom")) {
            schedulerFormData.delay = updateData["delay"];
            schedulerFormData.showDailySummary = updateData["showDailySummary"];
            updateData["allowUntillDuration"] = schedulerFormData.allowUntillDuration;
          }
          if (schedulerFormData.type == "milestone" || schedulerFormData.type == "custom") {
            if (!schedulerFormData.completionDuration) {
              schedulerFormData.completionDuration = updateData["completionDuration"];
            }
            if (!schedulerFormData.completionWindow) {
              schedulerFormData.completionWindow = updateData["completionWindow"];
            }
            if (!schedulerFormData.sequence) {
              schedulerFormData.sequence = updateData["sequence"];
            }
          }
          //calling checkDynamicFormAddHistory method for checking information for scheduler
          this.schedulerFormModifyStatus = this.checkDynamicFormAddHistory(schedulerFormData, mode != "edit" ? defaultScheduler : updateData);
          break;
        default:
          break;
      }
    },
    checkDynamicFormAddHistory(formData, defaultData) {
      const typeOfFormData = this.checkFormFieldType(formData);
      const typeOfDefaultData = this.checkFormFieldType(defaultData);
      return typeOfFormData == typeOfDefaultData ? this.compareFormDataUsingDataType(formData, defaultData) : false;
    },
    checkFormFieldType(formData) {
      //checking type of compare variable
      if (Array.isArray(formData)) {
        return "array";
      } else {
        return typeof formData;
      }
    },
    compareFormDataUsingDataType(formData, defaultData) {
      let mapFormData = [];
      const typeOfFormData = this.checkFormFieldType(formData);
      let formModifyStatus = true;
      switch (typeOfFormData) {
        case "string":
          formModifyStatus = formData == defaultData;
          break;
        case "number":
          formModifyStatus = formData == defaultData;
          break;
        case "boolean":
          formModifyStatus = toString(formData) == toString(defaultData);
          break;
        case "object":
          formModifyStatus = this.compareObjects(formData, defaultData);
          break;
        case "array":
          if (formData.length == defaultData.length) {
            mapFormData = formData.map((data, index) => {
              return this.compareObjects(data, defaultData[index]);
            });
          } else {
            mapFormData.push(false);
          }
          break;
        default:
          break;
      }
      if (mapFormData.indexOf(false) > -1) {
        return false;
      } else if (!formModifyStatus) {
        return false;
      } else {
        return true;
      }
    },
    //method having logic for comparing two nested object
    compareObjects(object1, object2) {
      const keys1 = Object.keys(object1);
      for (const key of keys1) {
        if (object2[key] == undefined) {
          // eslint-disable-next-line no-use-before-define
          object2[key] = this.definingData(val1);
        }
        if (object1[key] == null) {
          // eslint-disable-next-line no-use-before-define
          object1[key] = this.definingData(val2);
        }

        const val1 = object1[key];
        const val2 = object2[key];

        const areObjects = this.isObject(val1) && this.isObject(val2);
        if (Array.isArray(object1[key]) || Array.isArray(object2[key]) ? (Array.isArray(object1[key]) && Array.isArray(object2[key]) ? object1[key].length != object2[key].length : true) : false) {
          return false;
        } else if ((areObjects && !this.compareObjects(val1, val2)) || (!areObjects && val1 !== val2)) {
          return false;
        }
      }
      return true;
    },
    //method for checking variable is object
    isObject(object) {
      return object != null && typeof object === "object";
    },
    definingData(val) {
      if (Array.isArray(val)) {
        return [];
      } else if (this.isObject(val)) {
        return {};
      } else {
        return null;
      }
    }
  },
  computed: {
    ...mapGetters(["getDynamicActivitySchedules", "getDynamicActivityScheduleForEditing"])
  },
  watch: {
    getDynamicActivityScheduleForEditing: {
      deep: true,
      handler: function(newData) {
        if (newData && newData.data) {
          this.editIndex = newData.index;
          this.addOrEditMode = newData.addOrEditMode;
          this.dynamicScheduling = newData.data;
          this.disableNext = false;
        } else {
          this.editIndex = newData.index;
          this.addOrEditMode = newData.addOrEditMode;
          this.dynamicScheduling = {
            conditions: [],
            actions: [],
            scheduling: []
          };
          this.disableNext = true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .modal {
  top: 6% !important;
  bottom: auto !important;
  font-family: RobotoRegular !important;
  line-height: 1.5 !important;
  max-height: 80vh !important;

  &::-webkit-scrollbar {
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 4px;
    height: 3px;
    border: 3px solid transparent;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }
}
/deep/ .modal-dialog {
  width: 100% !important;
}
/deep/ .modal-body {
  padding: 25px 0 !important;
}

@media (min-width: 992px) {
  /deep/ .modal-lg {
    max-width: 1122px !important;
  }
}
.dynamic-scheduler-container {
  padding-right: 0 !important;
  padding-left: 0 !important;
  & .header {
    & .title {
      font-family: "RobotoRegular";
      font-size: 18px;
      font-weight: 600;
      color: #000;
      padding-left: 13px;
    }

    & .step-count {
      font-family: "RobotoRegular";
      font-size: 14px;
      font-weight: normal;
      margin-left: 1%;
      color: #959fa4;
      border-radius: 3px;
      background-color: #e2e7ea;
      padding: 0.2% 0.8% 0.3% 0.7%;
    }
  }
  & .gray-clr {
    color: #959fa4;
    margin-right: 2px;
    font-size: 16px;
  }
  & .footer-btns-container {
    font-family: "Roboto-Regular";
    font-weight: lighter;
    font-size: 14px;
    border-radius: 4px;
    border: none;

    &.cancel,
    &.back {
      background-color: #fff;
      color: #666669;
      cursor: pointer;
      padding: 0.5% 2.5% 0.6% 2.5%;
    }
    &.save {
      background-color: #4c8ce4;
      color: #fff;
      margin-left: 0.1%;
      cursor: pointer;
      padding: 0.6% 3.2% 0.7% 3.2%;
    }
    &:disabled {
      background-color: #bcd4f5;
      cursor: not-allowed;
      padding: 0.6% 3.2% 0.7% 3.2%;
    }
  }
}
</style>
